export const SGA_SPEND_EVIDENCE_KEY_BY_LEVER = {
  professional_fees: 'approved_professional_fees_snapshot',
  outside_contractors: 'approved_outside_contractors_snapshot',
  indirect_procurement: 'approved_indirect_procurement_snapshot',
  travel_and_expense: 'approved_tne_snapshot',
  shared_services: 'approved_shared_services_snapshot',
  tech_software: 'approved_tech_software_snapshot',
  real_estate_footprint: 'approved_real_estate_footprint_snapshot',
  marketing_spend: 'approved_marketing_spend_snapshot',
} as const;

export const SGA_SPEND_EVIDENCE_KEYS = {
  certifiedLeverMetrics: 'certified_sga_lever_metrics',
  financeLineReconciliation: 'finance_sga_line_reconciliation',
  policyLeakageSnapshot: 'approved_sga_policy_leakage_snapshot',
  programCostSnapshot: 'approved_sga_program_cost_snapshot',
  ownerMap: 'approved_sga_owner_map',
  scenarioAssumptions: 'approved_sga_scenario_assumptions',
  recurringClassification: 'approved_sga_recurring_classification',
  recoveryEvidence: 'approved_sga_recovery_evidence',
  controlPlan: 'approved_sga_control_plan',
  target: 'approved_sga_target',
  observedSpendFeed: 'observed_sga_spend_feed',
  benchmarkProfileArtifact: 'sga_benchmark_profile_artifact',
  approvedFinanceAgpMetric: 'approved_finance_agp_metric',
  formulaRuntimeReceipts: 'sga_formula_runtime_receipts',
  costPoolMapping: 'sga_cost_pool_mapping',
  governedFloor: 'approved_sga_q04_governed_floor',
  // Q04 value-bridge objective floor. Registered here 2026-08-04 so the identity
  // is derived rather than restated: sga-spend.rules.ts and its specs previously
  // carried it as a raw literal.
  objectiveFloor: 'sga_spend_objective_floor',
} as const;

export type SgaSpendEvidenceKey =
  (typeof SGA_SPEND_EVIDENCE_KEY_BY_LEVER)[keyof typeof SGA_SPEND_EVIDENCE_KEY_BY_LEVER];
